import { FormControl, ListItemIcon, MenuItem, Select } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Check, Public } from '@material-ui/icons';
import { useIntl } from 'react-intl';

import { AvailableLocale, LOCALE_LABELS, LOCALES } from 'config/locale';
import { useLocale } from 'providers/I18nProvider';

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    minWidth: 160,
  },
  select: {
    backgroundColor: theme.palette.common.white,
    fontSize: 14,
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
      paddingTop: 10,
      paddingBottom: 10,
    },
  },
  selectedValue: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  menuIcon: {
    minWidth: 24,
    color: theme.palette.text.primary,
  },
  iconPlaceholder: {
    width: 24,
    height: 24,
  },
  earthIcon: {
    fontSize: 18,
  },
  checkIcon: {
    fontSize: 18,
  },
}));

export default function LocaleSelect() {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { locale, setLocale } = useLocale();

  return (
    <FormControl variant="outlined" size="small" className={classes.formControl}>
      <Select
        className={classes.select}
        value={locale}
        onChange={(event) => setLocale(event.target.value as AvailableLocale)}
        renderValue={(value) => (
          <span className={classes.selectedValue}>
            <Public className={classes.earthIcon} />
            {LOCALE_LABELS[value as AvailableLocale]}
          </span>
        )}
        inputProps={{
          'aria-label': formatMessage({ id: 'locale.select-label' }),
        }}
      >
        {LOCALES.map((code) => (
          <MenuItem key={code} value={code} className={classes.menuItem}>
            <ListItemIcon className={classes.menuIcon}>
              {locale === code ? <Check className={classes.checkIcon} /> : <span className={classes.iconPlaceholder} />}
            </ListItemIcon>
            {LOCALE_LABELS[code]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
